import GlobalSettings from '@/GlobalSettings'
import { IKDataEntity } from 'metaflow-js'
import hillo from 'hillo'

const entity = {
  id: {
    type: IKDataEntity.Types.Integer,
    displayName: 'id',
    tableConfig: {
      align: 'start',
    },
    formConfig: {
      requiredNew: false,
    },
  },
  name: {},
  lang: {},
}
const config = {
  load: async function (filter) {
    return (await hillo.get('CategoryType.php', {
      lang: GlobalSettings.getLang(),
      ...filter,
    }))
      .content
  },
}

export default IKDataEntity.ModelFactory(entity, config)
